import React from 'react';
import { connect } from 'react-redux';
import { Alert, Tabs } from 'antd';
import { useT } from 'hooks/Locale/useT';
import useQueryApiClient from 'utils/useApiClient';
import { SupportSettingsOwnerType, UserValidationType } from '../../types';
import GlobalValidationRules from './GlobalValidationRules';
import OwnerValidationRules from './OwnerValidationRules';

const { TabPane } = Tabs;

const mapStateToProps = (state: any) => {
    return {
        session: state.session,
    };
};

interface UserValidationsTabProps {
    type: SupportSettingsOwnerType;
    selectedResellerId: number;
    selectedCustomerId: number;
    session: any;
}

interface UserValidationsStatusResponse {
    data: {
        enforcementEnabled: boolean;
    };
}

interface ValidationTypeOption {
    value: UserValidationType;
    labelId: string;
}

const VALIDATION_TYPES: ValidationTypeOption[] = [
    { value: 'EMAIL_DOMAIN', labelId: 'system.environment.validation_type_EMAIL_DOMAIN' },
];

const UserValidationsTab: React.FC<UserValidationsTabProps> = ({
    type,
    selectedResellerId,
    selectedCustomerId,
    session,
}) => {
    const t = useT();

    const isPlatformAdmin =
        session?.active_user_type === 'SUPER_ADMIN' || session?.active_user_type === 'DISTRIBUTOR_ADMIN';

    const { data: statusResponse } = useQueryApiClient({
        request: {
            url: 'api/v1/user-validations/status',
        },
    });

    const enforcementEnabled = (statusResponse as UserValidationsStatusResponse | undefined)?.data
        ?.enforcementEnabled;

    return (
        <>
            {enforcementEnabled === false && (
                <Alert
                    className="mb-3"
                    message={t('system.environment.user_validation_enforcement_off')}
                    type="warning"
                    showIcon
                />
            )}
            <Tabs size="small">
                {VALIDATION_TYPES.map((validationType) => (
                    <TabPane tab={t(validationType.labelId)} key={validationType.value}>
                        {type === 'default' ? (
                            <GlobalValidationRules
                                validationType={validationType.value}
                                isPlatformAdmin={isPlatformAdmin}
                            />
                        ) : (
                            <OwnerValidationRules
                                validationType={validationType.value}
                                type={type}
                                selectedResellerId={selectedResellerId}
                                selectedCustomerId={selectedCustomerId}
                            />
                        )}
                    </TabPane>
                ))}
            </Tabs>
        </>
    );
};

export default connect(mapStateToProps)(UserValidationsTab);
